"use client";

import {
  CopyButton,
  Notice,
  TextAreaField,
} from "@/components/tool-kit/primitives";
import { HINT, WIDGET_H3 } from "@/components/tool-kit/styles";
import { useToolNumber } from "@/components/tools/tool-ui";
import { t } from "@/lib/i18n/interpolate";
import { MESSAGE_LIMIT } from "@/lib/tool-kit/random-fun/discord-markdown";

export interface OutputStrings {
  outputLabel: string;
  copy: string;
  copied: string;
  characters: string;
  limitNote: string;
  emptyOutput: string;
}

/**
 * The finished text, a copy button and the length against Discord's message limit.
 * `shown` is what the box displays; `copyText` is what lands on the clipboard (they
 * differ for ANSI text, where the escape character is invisible).
 */
export function OutputBox({
  id,
  shown,
  copyText,
  strings,
}: {
  id: string;
  shown: string;
  copyText: string;
  strings: OutputStrings;
}) {
  const fmt = useToolNumber();
  if (shown === "") {
    return <Notice>{strings.emptyOutput}</Notice>;
  }
  const length = copyText.length;
  return (
    <div className="space-y-3">
      <TextAreaField
        id={id}
        label={strings.outputLabel}
        onChange={() => undefined}
        rows={Math.min(10, shown.split("\n").length + 1)}
        value={shown}
      />
      <div className="flex flex-wrap items-center gap-3">
        <CopyButton
          copiedLabel={strings.copied}
          label={strings.copy}
          text={copyText}
        />
        <p className={HINT}>{t(strings.characters, { count: fmt(length) })}</p>
      </div>
      {length > MESSAGE_LIMIT ? (
        <Notice>{t(strings.limitNote, { limit: fmt(MESSAGE_LIMIT) })}</Notice>
      ) : null}
    </div>
  );
}

export function PanelHeading({ children }: { children: string }) {
  return <h3 className={WIDGET_H3}>{children}</h3>;
}
